import Library from 'assets/images/cinema.png';
import EditIcon from 'assets/images/editPencil.svg';
import CheckIcon from 'assets/images/checkIcon.svg';
import DeleteIcon from 'assets/images/icons/DeleteIcon.svg';
import GenderIcon from 'assets/images/icons/GenderIcon.svg';
import HomeIcon from 'assets/images/icons/home.svg';
import SJPRIcon from 'assets/images/icons/menu-sjpr.svg';
import MyReportsIcon from 'assets/images/icons/my-reports.svg';
import TotalCashIcon from 'assets/images/icons/TotalCashIcon.svg';

import Home from 'assets/images/home.svg';
import Module from 'assets/images/modules.png';
import MyTasks from 'assets/images/MyTasks.svg';
import PayConfiguration from 'assets/images/PayConfiguration.svg';
import ReactLogo from 'assets/images/react.png';
import Remote from 'assets/images/remote.svg';
import Tailwind from 'assets/images/tailwind.png';
import Zustand from 'assets/images/zustand.png';
import { IIconProps } from 'model/interfaces';
import type { FC, HTMLAttributes, ImgHTMLAttributes, ReactNode } from 'react';

/** Define the Images object with the icons */
const Images: IIconProps = {
  Library,
  Home,
  Module,
  ReactLogo,
  Remote,
  Tailwind,
  Zustand,
  MyTasks,
  PayConfiguration,
  EditIcon,
  CheckIcon,
  GenderIcon,
  TotalCashIcon,
  DeleteIcon,
  HomeIcon,
  SJPRIcon,
  MyReportsIcon,
} as const;

/** Define a mapped type to ensure all properties are of type string */
type Stringify<T> = {
  [P in keyof T]:
    | string
    | ReactNode // ReactNode type
    | FC<HTMLAttributes<SVGElement>> //SVG type
    | FC<ImgHTMLAttributes<HTMLImageElement>>; //PNG type
};

/** Define TypedIcons directly with the correct types based on Images */
export const TypedIcons: Stringify<typeof Images> = Images;
